/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UnitAmenityTag {
    AFFORDABLE_SECTION_8 = 'affordable.section_8',
    AFFORDABLE_LIHTC = 'affordable.lihtc',
    BALCONY_PATIO = 'balcony_patio',
    BALCONY_PATIO_LARGE = 'balcony_patio.large',
    BALCONY_PATIO_PRIVATE = 'balcony_patio.private',
    CORNER_UNIT = 'corner_unit',
    DEN = 'den',
    DISHWASHER = 'dishwasher',
    FIREPLACE = 'fireplace',
    FLOOR = 'floor',
    FLOOR_PENTHOUSE = 'floor.penthouse',
    KITCHEN_ISLAND = 'kitchen_island',
    RENOVATED = 'renovated',
    RENOVATED_FULLY = 'renovated.fully',
    RENOVATED_PARTIALLY = 'renovated.partially',
    TOWNHOME = 'townhome',
    VIEW = 'view',
    VIEW_CITY = 'view.city',
    VIEW_COURTYARD = 'view.courtyard',
    VIEW_DIRECTION = 'view.direction',
    VIEW_MOUNTAINS = 'view.mountains',
    VIEW_POOL = 'view.pool',
    VIEW_WATER = 'view.water',
    VIEW_WOODS = 'view.woods',
    WALK_IN_CLOSET = 'walk_in_closet',
    WASHER_DRYER = 'washer_dryer',
    WASHER_DRYER_FULL_SIZE = 'washer_dryer.full_size',
    WASHER_DRYER_STACKABLE = 'washer_dryer.stackable',
    WASHER_DRYER_CONNECTIONS = 'washer_dryer_connections',
}
